import script from "./AdminTableButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTableButton.vue?vue&type=script&setup=true&lang=js"

import "./AdminTableButton.vue?vue&type=style&index=0&id=df8c8abe&lang=less"

const __exports__ = script;

export default __exports__